// Dependencies
import { Link } from "react-router-dom";

//Components
// Styles
import styled from "styled-components";
import { fontFamily, fontWeight } from "../../Styles/Cytoplasm";

export default function ModuleHeader(props) {
  return (
    <Header>
      <div
        className="header-item">
        <Link to="/">SYLLABUS</Link>
      </div>
    </Header>
  );
}

const Header = styled.header`
  position: relative;
  height: 4rem;
  z-index: 14;
  background-color: rgb(21, 20, 31);
  font-family: ${fontFamily.sansSerif};
  display: grid;
  align-items: center;
  padding: 0 25px;
  .header-item {
    a {
      text-decoration: none;
      color: white;
    }
  }
  @media (max-width: 430px) {
    display: none;
  }
`;
